<template>
	<b-col cols="3">
		<h4 class="mt-2">Saves</h4>
		<b-table-simple responsive small bordered striped table-class="mb-0">
			<b-tbody>
				<b-tr>
					<b-td><strong>FORT</strong> <small class="text-muted">Fortitude</small></b-td>
					<b-td class="text-right">{{(abilityMods.Constitution+Character.Levels[currentLevel].Fort)|bonus}}</b-td>
				</b-tr>
				<b-tr>
					<b-td><strong>REF</strong> <small class="text-muted">Reflex</small></b-td>
					<b-td class="text-right">{{(abilityMods.Dexterity+Character.Levels[currentLevel].Ref)|bonus}}</b-td>
				</b-tr>
				<b-tr>
					<b-td><strong>WILL</strong> <small class="text-muted">Will</small></b-td>
					<b-td class="text-right">{{(abilityMods.Wisdom+Character.Levels[currentLevel].Will)|bonus}}</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
	</b-col>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	computed: {
		Character: function(){
			return this.$store.state.Character
		},
		...mapGetters([
			'currentLevel',
		]),
		...mapGetters('character/abilityScores',[
			'abilityMods',
		]),
	}
}
</script>

<style scoped>

</style>